module.exports = __webpack_public_path__ + "google-play-badge.svg?642718c63ed4033034a0480aaf95f8ab";